import isEnumValue from '@orderna/admin-panel/src/utils/is-enum-value';

export enum Unit {
  MILLIGRAM = 'mg',
  GRAM = 'g',
  KILOGRAM = 'kg',
  METER = 'm',
  CENTIMETER = 'cm',
  MILLIMETER = 'mm',
  LITER = 'L',
  MILLILITER = 'mL',
  PIECE = 'pc',
  DOZEN = 'doz',
  HOUR = "hr",
  MINUTE = "min",
  SECOND = "sec",
}

export const isUnit = (value: any) => isEnumValue(Unit, value);

export interface WithUnit {
  unit: Unit;
}
